import { ButtonBase } from '@patrianna/core-components'
import type { ButtonBaseProps } from '@patrianna/core-components'
import clsx from 'classnames'
import * as React from 'react'

import ToolbarText from './ToolbarText'

export interface ToolbarButtonProps extends ButtonBaseProps {
  selected: boolean
  label: string
  align?: any
  typographyClassName?: string
}

const ToolbarButton = ({ className, label, selected, typographyClassName, ...other }: ToolbarButtonProps) => {
  return (
    <ButtonBase className={clsx(className)} {...other}>
      <ToolbarText className={typographyClassName} label={label} selected={selected} />
    </ButtonBase>
  )
}

export default ToolbarButton
